import { IBKJComboBoxProps } from '@bookjane2/bookjane-design-library/lib/components/BKJComboBox/BKJComboBox.types';
import i18next from 'i18next';

export const availabilityDurationOptions = (): IBKJComboBoxProps['options'] => [
  { id: '1', label: `1 ${i18next.t('WEEK')}`, value: '1' },
  { id: '2', label: `2 ${i18next.t('WEEK')}s`, value: '2' },
  { id: '3', label: `3 ${i18next.t('WEEK')}s`, value: '3' },
  { id: '4', label: `4 ${i18next.t('WEEK')}s`, value: '4' },
];
